import React, { useState } from 'react';
import NavLinks from './NavLinks';
import { Link } from 'react-router-dom';

// Option sizes for the logo
const logoSizes = {
  small: "h-10 w-auto sm:h-12",
  medium: "h-12 w-auto sm:h-16",
  large: "h-14 w-auto sm:h-20",
  extraLarge: "h-16 w-auto sm:h-24"
} as const;

export default function Navbar() {
  // You can change 'medium' to any of the sizes above
  const [logoSize] = useState<keyof typeof logoSizes>("medium");

  return (
    <nav 
      className="bg-white shadow-md fixed w-full z-10"
      role="navigation"
      aria-label="Primary navigation"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center group">
            <div className="flex items-center transition-transform duration-200 ease-in-out group-hover:scale-105">
              <img 
                src="/FMPCA Logo3-navbar.png"
                alt="FMPCA Logo"
                className={`${logoSizes[logoSize]} transition-all duration-200`}
                aria-hidden="true"
              />
              <div className="flex flex-col ml-3">
                <span 
                  className="text-lg sm:text-xl font-semibold text-gray-900 hidden md:block leading-tight"
                  role="heading"
                  aria-level={1}
                >
                  Frederick Metabolic &
                  <br className="hidden lg:block" />
                  Primary Care Associates
                </span>
                <span 
                  className="text-lg font-semibold text-gray-900 md:hidden"
                  role="heading"
                  aria-level={1}
                >
                  FMPCA
                </span>
              </div>
            </div>
          </Link>
          <NavLinks />
        </div>
      </div>
    </nav>
  );
}